import apiService from "./BaseApi";
const ENDPOINT = "units";
import store from '@/store/index'

const isUploadFile = (file) => {
    const FileConstructor = typeof File !== "undefined" ? File : null;
    const BlobConstructor = typeof Blob !== "undefined" ? Blob : null;
    return (FileConstructor && file instanceof FileConstructor) || (BlobConstructor && file instanceof BlobConstructor);
}

const buildHistoricsPayload = async (unitId, historics) => {
    const historicsPayload = await Promise.all(historics.map(async (historic) => {
        const historicPayload = { ...historic };
        const file = historic.file_photo_account;
        delete historicPayload.file_photo_account;

        if (isUploadFile(file)) {
            const uploadResponse = await apiService.post(
                `unit-historic-storage/${encodeURIComponent(unitId)}/${encodeURIComponent(historic.month)}`,
                file,
                {
                    params: {
                        fileName: file.name || "conta.pdf",
                        currentUserId: store.state.currentUser?.uid
                    },
                    headers: {
                        "Content-Type": file.type || "application/pdf"
                    }
                }
            );
            const uploadData = uploadResponse.data?.data || {};
            if (!uploadData.path_file_photo_account) {
                throw new Error("Upload do arquivo do historico nao retornou caminho.");
            }
            historicPayload.path_file_photo_account = uploadData.path_file_photo_account;
            historicPayload.file_photo_account_name = uploadData.file_photo_account_name;
        }

        return historicPayload;
    }));

    return {
        data: {
            historics: historicsPayload,
            currentUserId: store.state.currentUser?.uid
        },
        config: undefined
    };
}

const UnitsService = {
    findAllByClient: async (idClient) => apiService.post(ENDPOINT + "/findAllByClient", { idClient, currentUserId: store.state.currentUser?.uid }),
    findAll: async () => apiService.post(ENDPOINT + "/findAll", { currentUserId: store.state.currentUser?.uid }),
    findAllFranchisee: async () => apiService.post(ENDPOINT + "/findAllWithFranchisse", { currentUserId: store.state.currentUser?.uid }),
    readingPeriodByUnit: async (unit_id) => apiService.post(ENDPOINT + "/readingPeriod/byUnit", { unit_id, currentUserId: store.state.currentUser?.uid }),

    createBaselineConfig: async (baselineConfig, unitId) => apiService.post(`${ENDPOINT}/${unitId}/baseline-configs`, { baselineConfig, currentUserId: store.state.currentUser?.uid }),
    getAllBaselineConfig: async (unitId) => apiService.get(`${ENDPOINT}/${unitId}/baseline-configs`, { params: { currentUserId: store.state.currentUser?.uid } }),
    getCurrentBaselineConfig: async (unitId) => apiService.get(`${ENDPOINT}/${unitId}/baseline-configs/current`, { params: { currentUserId: store.state.currentUser?.uid } }),
    getBaselineConfigById: async (unitId, id) => apiService.get(`${ENDPOINT}/${unitId}/baseline-configs/${id}`, { params: { currentUserId: store.state.currentUser?.uid } }),
    updateBaselineConfig: async (unitId, id, baselineConfig) => apiService.put(`${ENDPOINT}/${unitId}/baseline-configs/${id}`, { baselineConfig, currentUserId: store.state.currentUser?.uid }),
    deleteBaselineConfig: async (unitId, id) => apiService.delete(`${ENDPOINT}/${unitId}/baseline-configs/${id}`, { params: { currentUserId: store.state.currentUser?.uid } }),
    calculateUnitGoal: async (unitId, payload = {}) => {
        const body = {
            currentUserId: store.state.currentUser?.uid,
            periodDate: payload.periodDate,
        };

        if (payload.driverActualValue !== undefined && payload.driverActualValue !== null && payload.driverActualValue !== '') {
            body.driverActualValue = payload.driverActualValue;
        }

        return apiService.post(`${ENDPOINT}/${unitId}/goals/calculate`, body);
    },
    calculateUnitGoalTimeseries: async (unitId, payload = {}) => {
        const body = {
            currentUserId: store.state.currentUser?.uid,
            dateFrom: payload.dateFrom,
            dateTo: payload.dateTo,
            granularity: payload.granularity,
            viewMode: payload.viewMode,
        };

        if (payload.referenceDate) {
            body.referenceDate = payload.referenceDate;
        }

        if (payload.driverActualValue !== undefined && payload.driverActualValue !== null && payload.driverActualValue !== '') {
            body.driverActualValue = payload.driverActualValue;
        }

        return apiService.post(`${ENDPOINT}/${unitId}/goals/timeseries`, body);
    },

    createUnit: async (unit) => apiService.post(ENDPOINT, { unit, currentUserId: store.state.currentUser?.uid }),
    getUnitById: async (id) => apiService.get(ENDPOINT + "/" + id, { currentUserId: store.state.currentUser?.uid }),
    updateUnit: async (id, unit) => apiService.put(ENDPOINT + "/" + id, { unit, currentUserId: store.state.currentUser?.uid }),
    softDeleteUnit: async (id) => apiService.delete(ENDPOINT + "/soft/" + id),
    hardDeleteUnit: async (id) => apiService.delete(ENDPOINT + "/hard/" + id),

    createSubCollectionHistorics: async (unitId, historics) => {
        const { data, config } = await buildHistoricsPayload(unitId, historics);
        return apiService.post(`${ENDPOINT}/${unitId}/historics`, data, config);
    },
    getSubCollectionHistorics: async (unitId) => apiService.get(`${ENDPOINT}/${unitId}/historics`, { params: { currentUserId: store.state.currentUser?.uid } }),
    updateSubCollectionHistorics: async (unitId, historics) => {
        const { data, config } = await buildHistoricsPayload(unitId, historics);
        return apiService.put(`${ENDPOINT}/${unitId}/historics`, data, config);
    },
    getHistoricFileDownloadURL: async (unitId, path) => apiService.get(`${ENDPOINT}/${unitId}/historics/file-url`, { params: { path, currentUserId: store.state.currentUser?.uid } }),
};

export default UnitsService;
